import styles from './OverallAppOverlay.module.scss';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectShowOverallAppOverlay } from 'selectors/selectors';

const OverallAppOverlay = () => {
    const shouldShowOverlay = useSelector(selectShowOverallAppOverlay);

    const handleDisableScrolling = (event) => event.preventDefault();
    const disableScrolling = () => {
        window.addEventListener('wheel', handleDisableScrolling, {
            passive: false
        });
    };

    const enableScrolling = () => {
        window.removeEventListener('wheel', handleDisableScrolling);
    };

    useEffect(() => {
        if (shouldShowOverlay) {
            disableScrolling();
        }

        return () => {
            enableScrolling();
        };
    }, [shouldShowOverlay]);

    return shouldShowOverlay && <div className={styles.wrapper} />;
};

export default OverallAppOverlay;
